export default {"src":"/_next/static/media/icon-explain-info.f6567255.svg","height":70,"width":72,"blurWidth":0,"blurHeight":0};